import { Link } from "react-router-dom";
import { Phone, ArrowLeft, Wrench } from "lucide-react";
import { COMPANY, SERVICES } from "@/content";
import CallLink from "@/components/CallLink";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("Page Not Found");
  return (
    <section data-testid="not-found-page" className="min-h-screen bg-charcoal text-bone flex items-center pt-28 pb-20">
      <div className="mx-auto max-w-7xl px-5 md:px-10 grid lg:grid-cols-[1.3fr_1fr] gap-12 items-center w-full">
        <div>
          <p className="text-terracotta text-xs md:text-sm tracking-[0.3em] uppercase font-semibold mb-5">Error 404</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">Looks like this page lost its cool.</h1>
          <p className="mt-6 max-w-lg text-bone/80 text-base md:text-lg leading-relaxed">
            The page you're looking for doesn't exist or has moved. Let's get you back to something that works — like your A/C.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <Link to="/" data-testid="not-found-home-btn" className="inline-flex items-center justify-center gap-2 rounded-full bg-terracotta px-7 py-3.5 font-semibold text-bone hover:bg-terracotta-dark hover:-translate-y-0.5 transition-all duration-200">
              <ArrowLeft size={17} /> Back to home
            </Link>
            <CallLink data-testid="not-found-call-btn" className="inline-flex items-center justify-center gap-2 rounded-full border border-bone/40 bg-bone/5 backdrop-blur px-7 py-3.5 font-semibold text-bone hover:bg-bone/15 transition-colors duration-200">
              <Phone size={16} /> {COMPANY.phone}
            </CallLink>
          </div>
        </div>
        <div className="rounded-3xl border border-bone/15 bg-bone/5 p-7">
          <p className="flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-bone/60 mb-4"><Wrench size={14} className="text-terracotta" /> Popular pages</p>
          <ul className="divide-y divide-bone/10">
            {SERVICES.map((s) => (
              <li key={s.path}>
                <Link to={`/services/${s.path}`} data-testid={`not-found-service-${s.slug}`} className="block py-3 font-medium hover:text-terracotta transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
